export default {
  // API_URL: 'http://localhost:8080',
  API_URL: `https://myflix-zag.herokuapp.com`
}